<!-- successPart -->
<template>
  <section class="successPart">
    <div class="textPart">
      <div class="iconPart">
        <i class="successIcon"></i>
        <i class="processIcon"></i>
        <i class="stepIcon"></i>
      </div>
      <div class="textArea">
        <p :class="['successText', { successTextOneline: expireType === 1 || !expiredText }]">
          {{ successTypeText }}成功
        </p>
        <p class="tipText">{{ expiredText }}</p>
        <p class="addText">{{ stepText }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    successTypeText: {
      type: String,
      default: '',
    },
    stepText: {
      type: String,
      default: '',
    },
    expireType: {
      type: Number,
      default: NaN,
    },
    invalidTime: {
      type: String,
      default: '',
    },
    containPackage: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      expiredText: '',
    };
  },
  watch: {
    expireType: {
      handler(val) {
        if (this.containPackage) return;
        if (val === 2) {
          this.expiredText = '有效期从现在开始计算，请合理安排学习时间';
        } else if (val === 3 && this.invalidTime) {
          this.expiredText = `${this.invalidTime}失效，请合理安排学习时间`;
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.successPart {
  display: flex;
  flex-direction: column;
  align-items: center;

  .textPart {
    display: flex;
    width: 100%;
    padding: 0 67px;

    .iconPart {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 78px;
      margin-top: 11px;

      i {
        display: block;
      }

      .successIcon {
        width: 51px;
        height: 51px;
        margin-bottom: 18px;
        background: url('../../../assets/img/payment/pay_success.png') no-repeat center;
        background-size: contain;
      }

      .processIcon {
        width: 7px;
        height: 42px;
        margin-bottom: 20px;
        background: #ff6c02;
        border-radius: 4px;
      }

      .stepIcon {
        position: relative;
        width: 49px;
        height: 49px;
        background: url('../../../assets/img/payment/step_circle.png') no-repeat center center;
        background-size: contain;
        border-radius: 24.5px;

        &::after {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 31px;
          height: 36px;
          background: url('../../../assets/img/payment/step_text.png') no-repeat center center;
          background-size: contain;
          transform: translate(-50%, -50%);
          content: '';
        }
      }
    }

    .textArea {
      .successText {
        height: 40px;
        margin-bottom: 5px;
        color: #333;
        font-weight: 600;
        font-size: 29px;
        line-height: 40px;

        &Oneline {
          position: relative;
          top: 19px;
        }
      }

      .tipText {
        height: 31px;
        margin-bottom: 71px;
        color: #787878;
        font-weight: 400;
        font-size: 22px;
        line-height: 31px;
      }

      .addText {
        height: 40px;
        color: #333;
        font-weight: 500;
        font-size: 29px;
        line-height: 40px;
      }
    }
  }
}
</style>
